module.exports = __webpack_public_path__ + "static/img/6.b57e6f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/6.png
// module id = c6Zl
// module chunks = 0